export default __webpack_public_path__ + "static/media/CRTorpedoClosed.8a721551.jpg";